import { useCallback, useState } from "react";
import { Tooltip, Whisper } from "rsuite";
import _ from "underscore";
import { getTextColor } from "utils/DashboardUtils";
import { getHoverColor } from "utils/DashboardUtils";

const defaultBackgroundColor = "#e8edea";

const SelectableOption = ({
  option,
  value,
  multiselect,
  onSelect,
  onDeselect,
  labelKey,
  valueKey,
  colorKey,
}) => {
  const [hovered, setHovered] = useState(null);
  const isSelected = useCallback(
    (option) => {
      if (
        multiselect &&
        value?.length &&
        _.findWhere(value, {
          [valueKey]: option?.[valueKey],
          [labelKey]: option?.[labelKey],
        })
      ) {
        return true;
      } else if (value?.[valueKey] === option?.[valueKey]) {
        return true;
      }

      return false;
    },
    [value, multiselect, labelKey, valueKey]
  );

  return (
    <>
      <Whisper
        // delayOpen={400}
        trigger="hover"
        placement="auto"
        speaker={<Tooltip>{option?.[labelKey]}</Tooltip>}
      >
        <div
          onMouseEnter={() => setHovered(option)}
          onMouseLeave={() => setHovered(null)}
          onClick={() => {
            if (isSelected(option)) return onDeselect(option);
            onSelect(option);
          }}
          className={`px-2 d-inline-block font-weight-500 cursor-pointer`}
          style={{
            width: "100%",
            background:
              hovered === option
                ? getHoverColor(option?.[colorKey])
                  ? getHoverColor(option?.[colorKey])
                  : option?.[colorKey]
                  ? option?.[colorKey]
                  : defaultBackgroundColor
                : option?.[colorKey]
                ? option?.[colorKey]
                : defaultBackgroundColor,
            color: getTextColor(
              option?.[colorKey] ? option?.[colorKey] : defaultBackgroundColor
            ),
            borderRadius: 3,
            fontSize: 14,
            padding: "0.25rem",
            position: "relative",
            transition: "background 0.05s ease-in-out",
            height: "31px",
          }}
        >
          <div
            className="d-inline-block text-truncate"
            style={{
              width: isSelected(option) ? "calc(100% - 25px)" : "100%",
            }}
          >
            {option?.icon && (
              <i
                className={`${option?.icon} mr-2`}
                style={{ position: "relative", top: 1, fontSize: 14 }}
              ></i>
            )}
            {option?.[labelKey]}
          </div>
          {isSelected(option) && (
            <div
              className="d-inline-block"
              style={{
                position: "absolute",
                right: "0.25rem",
                top: "-0.25rem",
              }}
            >
              <i
                className="mdi mdi-checkbox-marked"
                style={{
                  fontSize: 24,
                  color: getTextColor(
                    option?.[colorKey]
                      ? option?.[colorKey]
                      : defaultBackgroundColor
                  ),
                }}
              ></i>
            </div>
          )}
        </div>
      </Whisper>
    </>
  );
};

export default SelectableOption;
